/**
 * Lien vers la politique de confidentialité en vigueur (PDF, nouvel onglet). Mise à disposition
 * pour INFORMATION — aucune case, aucune acceptation (décision de Valérie, 13/10/2026).
 * Rien n'est affiché tant qu'aucune version n'est en vigueur.
 */
import { useTranslation } from "react-i18next";
import { publicLegalPdfUrl, useCurrentLegalDocuments } from "../hooks/useCurrentLegalDocuments";

export function PrivacyPolicyLink({ variant = "sentence", className, style }: {
  /** `sentence` : phrase d'information complète ; `label` : le seul intitulé (menu). */
  variant?: "sentence" | "label";
  className?: string;
  style?: React.CSSProperties;
}) {
  const { t } = useTranslation();
  const docs = useCurrentLegalDocuments();
  if (!docs?.privacy) return null;
  const link = (
    <a href={publicLegalPdfUrl(docs.privacy.id)} target="_blank" rel="noopener noreferrer" className="underline" style={{ color: "inherit" }}>
      {t(variant === "label" ? "legalLinks.privacyPolicy" : "legalLinks.privacyLink")}
    </a>
  );
  if (variant === "label") return <span className={className} style={style}>{link}</span>;
  return (
    <p className={className} style={style}>
      {t("legalLinks.privacyBefore")}{link}{t("legalLinks.privacyAfter")}
    </p>
  );
}
